import { render, staticRenderFns } from "./TestMain.vue?vue&type=template&id=15110fd6&scoped=true"
import script from "./TestMain.vue?vue&type=script&lang=js"
export * from "./TestMain.vue?vue&type=script&lang=js"
import style0 from "./TestMain.vue?vue&type=style&index=0&id=15110fd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15110fd6",
  null
  
)

export default component.exports